module.exports = __webpack_public_path__ + "static/media/hats.047f6189.jpeg";